// Buffer polyfill for browser
import { Buffer } from 'buffer';
globalThis.Buffer = Buffer;
